module.exports = __webpack_public_path__ + "img/users_blue_icon.4af442cb.svg";